import {createSelector} from "reselect";

import {selectorMainTreeBibleVersions} from "./mainTree/selectors";
import {selectorSetting} from "./settings/selectors";
import { SETTING } from "../utils/settings/constants";
import { getBookIdWithPrefix } from "@/shared/utils/content/content";

export const selectorBookBaseBible = createSelector(
  selectorMainTreeBibleVersions,
  selectorSetting(SETTING.baseBible.id),
  (bibles, baseBible = SETTING.baseBible.default) => {
    const baseBibleId = getBookIdWithPrefix(baseBible);
    return bibles.find((b) => b.id === baseBibleId);
  },
);

